export default __webpack_public_path__ + "static/media/05_o_0.9afcf8e8.jpg";